import React from 'react';
import { Accordion } from 'react-bootstrap';
import faqImg from '../../assets/images/faq-img.png';

function Queries() {
  return (
    <section className="query-wrapper section-padding">
      <div className="container">
        <div className="row gy-5 gy-lg-0">
          <div className="col-lg-6">
            <div className="left-content">
              <img src={faqImg} alt="" className="img-fluid" />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="right-content">
              <div className="section-head">
                <span className="heading-bg">Query</span>
                <h2 className="section-title">
                  Answers to frequently asked questions
                  <span className="heading-dot" />
                </h2>
              </div>

              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Why do you need a plan?</Accordion.Header>
                  <Accordion.Body>
                    The development of the general plan of the site is the
                    placement of the future house on the site relative to other
                    buildings, neighboring plots, environmental zones, taking
                    into account insolation.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Features of the burn house style?
                  </Accordion.Header>
                  <Accordion.Body>
                    The development of the general plan of the site is the
                    placement of the future house on the site relative to other
                    buildings, neighboring plots, environmental zones, taking
                    into account insolation.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    What is the scandivian style?
                  </Accordion.Header>
                  <Accordion.Body>
                    The development of the general plan of the site is the
                    placement of the future house on the site relative to other
                    buildings, neighboring plots, environmental zones, taking
                    into account insolation.
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Queries;
